<script setup>
// core
import {useI18n} from "vue-i18n";
// components
import ButtonConfirm from "@/components/Recurring/ButtonConfirm";

const VIBER_SUPPORT_URL = "https://vb.me/ContactUs"

const emit = defineEmits(["nextStep"])

const {t: $t} = useI18n()

const contactViber = () => {
    window.open(VIBER_SUPPORT_URL, "_blank", "noopener");
};

const retry = () => {
    emit("nextStep", "activation");
};

const goBack = () => {
    emit("nextStep", "integration");
};
</script>

<template>
    <div class="block">
        <p class="blocked__status">
            <i class="fa fa-ban"></i>
            {{ $t("telephony.viber_blocked.mainheader") }}
        </p>

        <div class="block-text">
            <p>{{ $t("telephony.viber_blocked.reason") }}</p>

            <ol class="steps">
                <i18n-t keypath="telephony.viber_blocked.step_form" tag="li">
                    <template #link>
                        <a class="blocked__link" :href="VIBER_SUPPORT_URL" target="_blank" rel="noopener">
                            {{ $t("telephony.viber_blocked.form_link") }}
                        </a>
                    </template>
                </i18n-t>
                <i18n-t keypath="telephony.viber_blocked.step_section" tag="li">
                    <template #section><b>{{ $t("telephony.viber_blocked.section") }}</b></template>
                </i18n-t>
                <i18n-t keypath="telephony.viber_blocked.step_problem" tag="li">
                    <template #problem><b>{{ $t("telephony.viber_blocked.problem") }}</b></template>
                </i18n-t>
            </ol>

            <p class="note">{{ $t("telephony.viber_blocked.after") }}</p>
        </div>

        <div class="success-button">
            <button-confirm class="btn" @click="contactViber">
                {{ $t("telephony.viber_blocked.contact") }}
            </button-confirm>
            <button-confirm class="btnreverse" @click="retry">
                {{ $t("page.time_actv.button") }}
            </button-confirm>
            <button-confirm class="btnreverse" @click="goBack">
                {{ $t("page.time_actv.button1") }}
            </button-confirm>
        </div>
    </div>
</template>

<style lang="scss" scoped>
// the TimeExpired.vue layout with a step list and a third button
.block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 25px 30px;
    width: 100%;
    border-radius: 11px;
    background: var(--block-color);

    p,
    li {
        font-family: "Gilroy";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 25px;
        margin: 0 0 12px;
        color: var(--text-third-color);

        b {
            font-weight: 700;
            color: var(--text-color);
        }
    }

    .blocked__status {
        display: flex;
        align-items: center;
        gap: 12px;
        margin: 0;

        font-family: "Gilroy", sans-serif;
        font-size: 24px;
        font-weight: 700;
        line-height: 140%;
        color: var(--danger-color);

        i {
            font-size: 28px;
        }
    }

    // same as .activation__link in ActivationResult.vue
    .blocked__link {
        color: var(--general-color) !important;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
            text-underline-offset: 3px;
        }
    }

    .block-text {
        margin: 16px 0 20px;
    }

    .steps {
        margin: 0 0 12px;
        padding-left: 22px;

        li {
            margin-bottom: 8px;
        }
    }

    .block-text .note {
        margin: 0;
    }

    .success-button {
        display: flex;
        flex-wrap: wrap;
        gap: 9px 10px;

        .btnreverse {
            background: none;
            color: var(--general-color);
            transition: 0.25s;
            border: 1px solid;
            border-color: var(--general-color);

            &:hover {
                background: var(--general-color);
                color: white;
                border: none;
            }
        }
    }
}

@media screen and (max-width: 573px) {
    .block .success-button {
        width: 100%;
        margin: 0;

        .btn,
        .btnreverse {
            width: 100%;
            margin: 0;
        }
    }

    .block .block-text {
        margin: 12px 0 16px;
    }

    .block .blocked__status {
        font-size: 18px;

        i {
            font-size: 22px;
        }
    }
}
</style>
